import React, { FC } from 'react';

import { NutritionDisclaimer } from '../nutrition-disclaimer';
import { INutritionDisclaimer } from '../types';

export const NutritionModalDisclaimer: FC<INutritionDisclaimer> = ({ content }) => (
  <NutritionDisclaimer content={content} />
);
